const LoaderMini = () => (
  <div className="lds-ring-mini">
    <div />
  </div>
);

export default LoaderMini;
